/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerCreatedBy } from './get-fraud-locked-card-transaction200-response-one-of-evidence-list-inner-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrors } from './get-fraud-locked-card-transaction200-response-one-of-evidence-list-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerInvoiceIssuer } from './get-fraud-locked-card-transaction200-response-one-of-evidence-list-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerUpdatedBy } from './get-fraud-locked-card-transaction200-response-one-of-evidence-list-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerUploadedBy } from './get-fraud-locked-card-transaction200-response-one-of-evidence-list-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarnings } from './get-fraud-locked-card-transaction200-response-one-of-evidence-list-inner-warnings';

/**
 * 
 * @export
 * @interface GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
 */
export interface GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'paymentType': GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'electronicMethod': GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'documentSize': GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'legalValidity': GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerInvoiceIssuer}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'invoiceIssuer': GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     * @deprecated
     */
    'dpiError': GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     * @deprecated
     */
    'colorGradationError': GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     * @deprecated
     */
    'heightMillisError': GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     * @deprecated
     */
    'widthMillisError': GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrors}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'errors': GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrors;
    /**
     * 
     * @type {GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarnings}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'warnings': GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarnings;
    /**
     * 
     * @type {GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerCreatedBy}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'createdBy': GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerUpdatedBy}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'updatedBy': GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerUploadedBy}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'uploadedBy': GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInner
     */
    'uploadedFrom': string;
}

export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerPaymentTypeEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerPaymentTypeEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerPaymentTypeEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerElectronicMethodEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerElectronicMethodEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerElectronicMethodEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerDocumentSizeEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerDocumentSizeEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerDocumentSizeEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerLegalValidityEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerLegalValidityEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerLegalValidityEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerDpiErrorEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerDpiErrorEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerDpiErrorEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerDetectedDpiErrorEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerDetectedDpiErrorEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerDetectedDpiErrorEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerCalculatedDpiErrorEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerCalculatedDpiErrorEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerColorGradationErrorEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerColorGradationErrorEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerColorGradationErrorEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerHeightMillisErrorEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerHeightMillisErrorEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerHeightMillisErrorEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWidthMillisErrorEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWidthMillisErrorEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWidthMillisErrorEnum];


